import type { IRogue } from '@/js/services/RogueTypes'

type DealType = {
  key: string,
  urlText?: string,
  title: string,
}

type DealsSEOConfig = {
  // Omitted on filtered views - see below
  canonical?: string,
  title: string,
}

// Params that leave /deals on one of its own addressable pages rather than an arbitrary filtered
// view: deal_type picks one of a fixed, linked set, page_number paginates, and srsltid is Google's
// own click-tracking param (allowlisted the same way category-meta-tags.ts does).
const CANONICAL_PARAMS = ['deal_type', 'page_number', 'srsltid']

export function getDealsMetaTags(
  query: Record<string, any>,
  rogue: IRogue,
  dealTypes: DealType[],
  baseTitle: string
): DealsSEOConfig {
  // The page links each tile as `urlText || key`, so normalise to that spelling - otherwise the
  // same deal type reached by its other name would canonicalise to a second URL.
  const dealType = query.deal_type
    ? dealTypes.find(t => query.deal_type === t.key || query.deal_type === t.urlText)
    : undefined

  const result: DealsSEOConfig = { title: dealType ? dealType.title : baseTitle }

  const isCanonicalShape = Object.keys(query).every(q => CANONICAL_PARAMS.includes(q))
    && (!query.deal_type || Boolean(dealType))

  if (!isCanonicalShape) {
    return result
  }

  // l10n.path is '' on the US site
  const url = new URL(`${rogue.l10n.path || ''}/deals`, rogue.baseURL)
  const page = parseInt(`${query.page_number || 1}`, 10)

  if (dealType) {
    url.searchParams.set('deal_type', dealType.urlText || dealType.key)
  }
  if (page > 1) {
    url.searchParams.set('page_number', `${page}`)
  }

  result.canonical = url.toString()

  return result
}
